// FILE: src/api/ownerInboxApi.js
import api from "./axios";

/**
 * ✅ Token based (recommended):
 *   GET  /owners/match-requests
 *   POST /owners/match-requests/{matchId}/accept
 *   POST /owners/match-requests/{matchId}/decline
 *
 * Legacy (still supported):
 *   GET  /owners/{ownerId}/match-requests
 *   POST /owners/{ownerId}/match-requests/{matchId}/accept
 *   POST /owners/{ownerId}/match-requests/{matchId}/decline
 */

// ✅ works with ()
// ✅ also works with (ownerId) but ignores it (keeps your current ManageBookings unchanged)
export async function fetchOwnerMatchRequests(_ownerIdUnused) {
  const { data } = await api.get(`/owners/match-requests`);
  return Array.isArray(data) ? data : [];
}

// ✅ support old signature: acceptOwnerMatchRequest(ownerId, matchId, payload)
// ✅ and new signature: acceptOwnerMatchRequest(matchId, payload)
export async function acceptOwnerMatchRequest(a, b, c) {
  let matchId;
  let payload;

  if (typeof b === "number" || typeof b === "string") {
    // old: (ownerId, matchId, payload)
    matchId = b;
    payload = c ?? {};
  } else {
    // new: (matchId, payload)
    matchId = a;
    payload = b ?? {};
  }

  if (!matchId) throw new Error("matchId is required");

  const body =
    payload && typeof payload === "object" && !Array.isArray(payload) ? payload : {};

  const { data } = await api.post(`/owners/match-requests/${matchId}/accept`, body);
  return data;
}

// ✅ support old signature: declineOwnerMatchRequest(ownerId, matchId, reason)
// ✅ and new signature: declineOwnerMatchRequest(matchId, reason)
export async function declineOwnerMatchRequest(a, b, c) {
  let matchId;
  let reason;

  if (typeof b === "number" || typeof b === "string") {
    matchId = b;
    reason = c ?? "";
  } else {
    matchId = a;
    reason = b ?? "";
  }

  if (!matchId) throw new Error("matchId is required");

  const payload = typeof reason === "string" ? reason : String(reason ?? "");

  const { data } = await api.post(
    `/owners/match-requests/${matchId}/decline`,
    payload,
    { headers: { "Content-Type": "text/plain" } }
  );

  return data;
}
